<template>
  <button class="button" :class="classes" :disabled="disabled" @click="$emit('click')">
    <slot />
  </button>
</template>

<script>
export default {
  name: 'SoButton',
  props: {
    variant: {
      type: String,
      required: false,
      default: 'default',
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    raised: {
      type: Boolean,
      required: false,
    },
    rounded: {
      type: Boolean,
      required: false,
    },
    noShadow: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    classes() {
      return {
        [this.variant]: true,
        disabled: this.disabled,
        raised: this.raised,
        pill: this.rounded,
        'no-shadow': this.noShadow,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 6px 12px;
  border: none;
  border-radius: 5px;
  box-shadow: 1px 3px 3px rgba(0, 0, 0, 0.16);
  background: #808080;
  color: #fff;
  font-weight: bold;
  text-decoration: none;
  outline: none;

  /* state */
  &.disabled {
    opacity: 0.65;
    box-shadow: none;
  }
  &:active {
    background: #666;
  }

  /* style */
  &.raised {
    padding: 6px 12px 4px;
    border-bottom: 2px solid #666;

    &.red {
      border-bottom: 2px solid #96131a;
    }
    &.gray {
      border-bottom: 2px solid #bfbfbf;
    }
  }
  &.pill {
    border-radius: 50rem;
  }
  &.no-shadow {
    box-shadow: none;
  }

  /* variant */
  &.red {
    background: #d21b24;

    &:hover,
    &:focus {
      background: #d21b24;
    }
    &:active {
      background: #ad1219;
    }
  }
  &.gray {
    color: #2c3e50;
    background: #e6e6e6;

    &:hover,
    &:focus {
      background: #e6e6e6;
    }
    &:active {
      background: #ddd;
    }
  }
}
</style>
